// =====================================================================
// Assessment Center — Student Panel
// Route definitions, mounted in src/App.tsx. Both route roots below
// are gated by RequireRole — an unauthenticated visitor, or a signed-
// in instructor, is redirected before either renders. The Exam Page
// route is intentionally outside StudentLayout's sidebar shell
// (full-bleed exam runner), while the other four pages use it.
// =====================================================================
import { Route } from "react-router-dom";
import { RequireRole } from "../../shared/auth/RequireRole";
import StudentLayout from "./components/StudentLayout";
import DashboardPage from "./pages/DashboardPage";
import AvailableExamsPage from "./pages/AvailableExamsPage";
import MyExamsPage from "./pages/MyExamsPage";
import ExamPage from "./pages/ExamPage";
import ResultsPage from "./pages/ResultsPage";

export const studentAssessmentCenterRoutes = (
  <>
    <Route
      path="/student/assessment-center"
      element={
        <RequireRole role="student">
          <StudentLayout />
        </RequireRole>
      }
    >
      <Route index element={<DashboardPage />} />
      <Route path="available-exams" element={<AvailableExamsPage />} />
      <Route path="my-exams" element={<MyExamsPage />} />
      <Route path="results/:attemptId" element={<ResultsPage />} />
    </Route>

    {/* Full-bleed exam runner — no sidebar chrome */}
    <Route
      path="/student/assessment-center/exams/:attemptId"
      element={
        <RequireRole role="student">
          <ExamPage />
        </RequireRole>
      }
    />
  </>
);
